import React from 'react';
import { Route, IndexRoute } from 'react-router';

import labelViewer from 'components/labelViewer/labelViewer.container';

const LabelViewerRoute = (
  <Route>
    <IndexRoute component={labelViewer} />
		<Route
			path='/labelViewer'
			component={labelViewer}
		>
      <Route
        path=':labelId'
        component={labelViewer}
      >
        <Route
          path=':parentId'
          component={labelViewer}
        />
      </Route>
    </Route>
  </Route>
);

export default LabelViewerRoute;



// WEBPACK FOOTER //
// ./src/components/labelViewer/labelViewer.routes.jsx